import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Apăsați butonul de mai jos pentru a revizui și confirma informațiile de plată.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Colaborăm cu Stripe pentru procesarea plăților. Stripe este cea mai sigură platformă de plăți, folosită de cele mai mari companii din lume.',
      form: {
        terms_acceptance: {
          label:
            'Prin continuare, acceptați <FoodAmigosTerms>Acordul nostru de servicii</FoodAmigosTerms> și <StripeTerms>Acordul de cont conectat Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements:
          'Stripe a marcat unele informații ale clientului ca lipsă sau invalide. Vă rugăm să corectați erorile de mai jos apăsând butonul „Deschide profilul Stripe":',
        errors: 'Erori',
        awaiting_verification: 'Contul dvs. Stripe este în curs de verificare',
        awaiting_verification_description:
          'Așteptăm ca Stripe să finalizeze verificarea afacerii dvs. Între timp, puteți revizui profilul.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Colaborăm cu Adyen pentru procesarea plăților. Adyen este una dintre cele mai sigure platforme de plată, utilizată de cele mai mari companii din lume.',
    },
  },
  labels: {
    verified: 'Contul dvs. {{paymentGateway}} este verificat',
    verified_description:
      'Verificarea pentru {{paymentGateway}} este finalizată. Puteți gestiona în continuare profilul dacă este necesar.',
  },
  buttons: {
    proceed: 'Confirmați informațiile de plată',
    copy_link: 'Copiați linkul',
  },
  toasts: {
    something_went_wrong: 'Ceva a mers greșit, vă rugăm să contactați suportul tehnic',
  },
};
